import { LogLevel } from '@loglayer/shared'
import { SeverityLevel } from '@sentry/core'

export const logLevelToSentrySeverityLevel: Record<LogLevel, SeverityLevel> = {
    [LogLevel.info]: 'info',
    [LogLevel.warn]: 'warning',
    [LogLevel.error]: 'error',
    [LogLevel.debug]: 'debug',
    [LogLevel.trace]: 'debug',
    [LogLevel.fatal]: 'fatal',
} as const

export const logLevel =
    Object.values(LogLevel).find((level) => level === process.env.EXPO_PUBLIC_LOG_LEVEL) ??
    LogLevel.warn
